import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Menu, Grid, Segment, List } from 'semantic-ui-react'

const propTypes = {
  groupNum : PropTypes.number
};

const defaultProps = {
  groupNum : 0
};

class Group extends Component {

  constructor(props) {
    super(props);
    this.state = {
      activeItem : ""
    }
  }

  handleItemClick = (e, { name }) => this.setState({ activeItem: name })

  click = (idx, name) => {

    const { sikdaeGroupClick } = this.props;
    sikdaeGroupClick(idx, name);
  }

  render() {

    const { activeItem } = this.state;
    const { sikdaeGroup, groupNum } = this.props;

    const style ={
      segment : {
        border: "0"
        , boxShadow: "none"
      }
      , active : {
        background : "rgba(0,0,0,.05)"
        // , color : "white"
      }

    }

    return(
      <Menu vertical className="vendysLeftMenu" fluid>
        <Menu.Item className="top" name="title">
          식대그룹
        </Menu.Item>
        {
          sikdaeGroup
          ? (
            sikdaeGroup.data.group.map((data, i) => {
              return (
                <Menu.Item
                  name={data.name}
                  active={groupNum === data.idx}
                  key={i}
                  onClick={(e) => this.click(data.idx, data.name)}
                >
                </Menu.Item>
              )
            })
          )
          : (
            null
          )
        }
      </Menu>
    );
  }
}

Group.propTypes = propTypes;
Group.defaultProps = defaultProps;

Group = connect(

  state => ({
    sikdaeGroup     : state.commons.sikdaeGroup
  })

)(Group);

export default Group;
